import { HttpClient } from '@angular/common/http'
import { inject, Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { map, Observable } from 'rxjs'

@Pipe({
  name: 'authImage',
  standalone: true,
})
export class AuthImagePipe implements PipeTransform {
  protected readonly http = inject(HttpClient)
  private readonly sanitizer = inject(DomSanitizer)

  transform(url: string): Observable<SafeUrl> {
    return this.http.get(url, { responseType: 'blob' }).pipe(
      map((blob) => {
        const urlCreator = window.URL
        const imageUrl = this.sanitizer.bypassSecurityTrustUrl(urlCreator.createObjectURL(blob))
        return imageUrl
      })
    )
  }
}
